import { Controller } from "@hotwired/stimulus"

/** Toggles the MMPI norm set field when a gender-capable instrument is selected. */
export default class extends Controller {
  static targets = ["testType", "summary", "normField", "normSelect"]
  static values = {
    summaries: { type: Object, default: {} },
    mmpiCode: { type: String, default: "mmpi_2" },
    genderCodes: { type: Array, default: [] }
  }

  connect() {
    this.update()
  }

  changed() {
    this.update()
  }

  update() {
    const code = this._selectedCode()
    this._setSummary(code)
    this._setNormVisible(this._needsNorms(code))
  }

  _selectedCode() {
    if (!this.hasTestTypeTarget) return ""
    const checked = this.testTypeTargets.find((el) => el.checked)
    if (checked) return checked.value
    return this.testTypeTarget.value || ""
  }

  _needsNorms(code) {
    if (this.genderCodesValue.length) {
      return this.genderCodesValue.includes(code)
    }
    return code === this.mmpiCodeValue
  }

  _setSummary(code) {
    if (!this.hasSummaryTarget) return
    this.summaryTarget.textContent = this.summariesValue[code] || ""
  }

  _setNormVisible(visible) {
    if (this.hasNormFieldTarget) {
      this.normFieldTarget.classList.toggle("is-hidden", !visible)
    }
    if (this.hasNormSelectTarget) {
      this.normSelectTarget.disabled = !visible
    }
  }
}
